import { Component } from '@angular/core';

@Component({
    selector: 'app-sign-out',
    templateUrl: './sign-out.component.html',
    styleUrls: ['./sign-out.component.scss'],
    standalone: false
})
export class SignOutComponent {

}
